import { render, staticRenderFns } from "./NationalPresidentFlagshipEdit.vue?vue&type=template&id=0abe05ad&scoped=true"
import script from "./NationalPresidentFlagshipEdit.vue?vue&type=script&lang=js"
export * from "./NationalPresidentFlagshipEdit.vue?vue&type=script&lang=js"
import style0 from "./NationalPresidentFlagshipEdit.vue?vue&type=style&index=0&id=0abe05ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe05ad",
  null
  
)

export default component.exports